// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__UBJFe","inputWrap":"styles_inputWrap__2e8Tx","input":"styles_input__3yCEX"};